import { render } from "./BatchStatusLegend.vue?vue&type=template&id=2d317ab7"
import script from "./BatchStatusLegend.vue?vue&type=script&lang=js"
export * from "./BatchStatusLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__